import { useRequireAuth } from '@/hooks/use-require-auth'
import { ProfileClient } from './profile/client-page'

export function Profile() {
  useRequireAuth()

  return <ProfileClient />
}